module.exports = __webpack_public_path__ + "img/blog-adobe-vs-magento-img.eae60af8.webp";